// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1726":"f5bb5a30","8573":"64044193","8639":"64044193"}[chunkId] + ".chunk.css";
};